var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowUpLong(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M165.656 0C162.531 -3.125 157.469 -3.125 154.344 0L2.344 152C0.781 153.562 0 155.594 0 157.656S0.781 161.75 2.344 163.312C5.469 166.437 10.531 166.437 13.656 163.312L152 24.969V501.656C152 506.062 155.578 509.656 160 509.656S168 506.062 168 501.656V24.969L306.344 163.312C309.469 166.437 314.531 166.437 317.656 163.312S320.781 155.125 317.656 152L165.656 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpLong);
export default __webpack_public_path__ + "static/media/arrow-up-long.12339f240e3e884ccac794fa0317062a.svg";
export { ForwardRef as ReactComponent };